/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


export enum EntityTreeBranchTypeEnum {
    CLAIM = 'Claim',
    SPO = 'Spo',
    PNC = 'PNC'
}
